import React from 'react'

const NoneFound = () => (
  <p className='text-center'>No models found!</p>
)

export default NoneFound
